<template>
  <div class="col-xl-3 mb-3">
       <h5 class="title-section">Enrollment by Top {{ memberDataByStates.length }} States</h5>
       <div
         class="overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2"
       >
         <div class="table-responsive">
           <table class="table">
             <thead>
               <tr>
                 <th>State</th>
                 <th>Enrolled (in %)</th>
               </tr>
             </thead>
             <tbody>
               <tr v-for="item in memberDataByStates" :key="item.state">
                 <td>{{ item.state }}</td>
                 <td>{{ item.percentage }}</td>
               </tr>
             </tbody>
           </table>
         </div>
       </div>
     </div>
</template>

<script>
export default{
 props:{
     memberDataByStates:Array
 }
}
</script>